const DATA = [
    {
        one: 10000,
        low: 10000,
        mid: 10000,
        up: 10000,
        ninetyNine: 10000,
        contribution: 10000,
        lowRange: [10000, 10000],
        highRange: [10000, 10000],
    },
    {
        one: 9250,
        low: 9800,
        mid: 10300,
        up: 11000,
        ninetyNine: 12500,
        contribution: 11987.67,
        lowRange: [9500, 10500],
        highRange: [10500, 11500],
    },
    {
        one: 9000,
        low: 10000,
        mid: 10900,
        up: 12100,
        ninetyNine: 13000,
        contribution: 11983.67,
        lowRange: [9450, 11400],
        highRange: [11400, 13000],
    },
    {
        one: 9250,
        low: 10350,
        mid: 11700,
        up: 13500,
        ninetyNine: 16638.19974332482,
        contribution: 11991.67,
        lowRange: [9650, 12400],
        highRange: [12400, 14500],
    },
    {
        one: 11000,
        low: 11000,
        mid: 12800,
        up: 15300,
        ninetyNine: 16000,
        contribution: 11995.67,
        lowRange: [9900, 13700],
        highRange: [13700, 16200],
    },
];

export default {
    DATA,
};
